module.exports = __webpack_public_path__ + "img/paragraphold.3255c9d6.svg";